import React from "react";
import styled from "styled-components";
import data from "./data";
import Shell from "../../UI/Templates/Shell";
import Hero from "../../UI/Hero/Hero";
import Blurb from "../../UI/Media/Blurb";
import Grid from "../../UI/Layout/Grid";
import Container from "../../UI/Layout/Container";
import Footer from "../../UI/Footer/Footer";
import Card from "../../UI/Card/Card";
import CardList from "../../UI/Card/CardList";
import Item from "../../UI/Item/Item";
import Text from "../../UI/Text/Text";
import Button from "../../UI/Button/Button";
import Box from "../../UI/Layout/Box";
import Arrow from "../../UI/Button/Arrow";

const TYPES = [
  { name: "Database", icon: "book", color: "#83a1bd" },
  {
    name: "Projects & Activities",
    icon: "map",
    color: "#83a1bd",
    link:
      "/aot/projects?access_token=pk.eyJ1IjoiZGFuaWNhdGFsYW4iLCJhIjoiY2o4eWVybGJxMXViYjJwcWNyZ3poa3NqcyJ9.mWTnxEb_B2h_x11wdtwFeQ"
  },
  {
    name: "Learning",
    icon: "player",
    color: "#83a1bd",
    link: "/aot/learning"
  },
  {
    name: "Exchange",
    icon: "comment",
    color: "#83a1bd",
    link: "/aot/exchange/1"
  }
];

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navbar: {
        instance: "aot",
        logoAlt: "Atlas of Torture",
        logo: "/aot-logo.png",
        links: [
          { title: "Home", url: "/" },
          { title: "About us" },
          { title: "Database" },
          {
            title: "Projects & Activities",
            url:
              "/projects?access_token=pk.eyJ1IjoiZGFuaWNhdGFsYW4iLCJhIjoiY2o4eWVybGJxMXViYjJwcWNyZ3poa3NqcyJ9.mWTnxEb_B2h_x11wdtwFeQ"
          },
          { title: "Learning", url: "/learning" },
          { title: "Exchange", url: "/exchange/1" },
          { title: "Contact" }
        ]
      },
      hero: {
        instance: "aot",
        title: "Atlas of Torture",
        titleImg: "/aot-logo.png",
        search: "Search documents, projects, activities...",
        description: "top",
        gradient: true
      },
      instance: data.instance,
      sidepanel: ""
    };
  }

  render() {
    return (
      <Component>
        <Shell data={this.state} />
        <Hero {...this.state.hero}>
          <p>Advancing the fight against torture</p>
        </Hero>
        <Container>
          <div
            style={{
              background: "#feffcc",
              padding: "15px",
              borderRadius: "4px",
              color: "#a55f2a",
              textAlign: "center"
            }}
          >
            The database is currently undergoing a testing phase. If you have
            any comments or suggestions, please{" "}
            <a href="mailto:contact@atlas-of-torture.org">let us know</a>!
          </div>
          <a
            href="https://twitter.com/atlasoftorture"
            target="_blank"
            style={{ border: 0 }}
          >
            <img
              src="/crowdfunding-banner.png"
              style={{ margin: "32px 0 0" }}
            />
          </a>
          <Grid style={{ paddingTop: 32 }}>
            <Box>
              <Text size="lg">
                The Atlas of Torture is a ‘one-stop-shop’ for information on
                torture and ill-treatment and strategies for their prevention.
                It is a resource for the entire community to learn more about
                torture and ill-treatment, share their work and ideas, and get
                in touch.
              </Text>
              <Text size="lg">
                Because there is evidence that torture prevention works – the
                Atlas of Torture is a tool to empower human rights defenders and
                advance the fight against torture and through documentation,
                learning, and exchange.
              </Text>
            </Box>
          </Grid>
          <Grid wrap>
            {TYPES.map((entry, i) => (
              <Box width={["100%", "25%"]}>
                <Blurb
                  key={i}
                  link={entry.link}
                  color={entry.color}
                  icon={entry.icon}
                >
                  {entry.name}
                </Blurb>
              </Box>
            ))}
          </Grid>
        </Container>
        <Box
          style={{
            background: "#f4f7f9",
            padding: "1px 0 32px 0"
          }}
        >
          <Container>
            <h2>News</h2>
            <CardList>
              {data.home.map((item, i) => (
                <Card
                  width={["calc(100% - 15px)", "calc(33.333% - 15px)"]}
                  key={i}
                >
                  <Item data={item} />
                </Card>
              ))}
            </CardList>
            <br />
            <center>
              <Button>
                <Arrow />
                View in library
              </Button>
            </center>
          </Container>
        </Box>
        <Container>
          <Grid>
            <Box style={{ paddingRight: 15 }}>
              <a
                href="https://twitter.com/atlasoftorture"
                target="_blank"
                style={{ border: 0 }}
              >
                <img
                  src="/follow-twitter.png"
                  style={{ margin: "32px 0", width: "100%" }}
                />
              </a>
            </Box>
            <Box style={{ paddingLeft: 15 }}>
              <a
                href="https://twitter.com/atlasoftorture"
                target="_blank"
                style={{ border: 0 }}
              >
                <img
                  src="/follow-facebook.png"
                  style={{ margin: "32px 0", width: "100%" }}
                />
              </a>
            </Box>
            <Box style={{ paddingLeft: 15 }}>
              <a
                href="https://twitter.com/atlasoftorture"
                target="_blank"
                style={{ border: 0 }}
              >
                <img
                  src="/follow-vimeo.png"
                  style={{ margin: "32px 0", width: "100%" }}
                />
              </a>
            </Box>
          </Grid>
          <Footer instance="Atlas of Torture" />
        </Container>
      </Component>
    );
  }
}

const Component = styled.div``;



// WEBPACK FOOTER //
// ./src/Containers/AOT/Home.js